import React from "react";
import { Panel } from "primereact/panel";
import { ScrollPanel } from "primereact/scrollpanel";
import classes from "./FooterMenu.module.scss";

interface Props {
  children: React.ReactNode;
  title: string;
}

const FooterMenu: React.FC<Props> = ({ children, title }) => {
  return (
    <div className={classes.footerMenu}>
      <Panel header={title}>
        <ScrollPanel style={{ width: "100%", height: "100%" }}>
          {children}
        </ScrollPanel>
      </Panel>
    </div>
  );
};

export default FooterMenu;
